import Vue from 'vue'

/**
 * Uygulama genelinde basit event bus.
 * Birbirini doğrudan tanımayan componentlerin haberleşmesi için kullanılır.
 */
export const EventBus = new Vue()

/** Gelişim Envanteri popup'ını her yerden açmak için kullanılan event adı. */
export const GROWTH_INVENTORY_OPEN = 'growth-inventory:open'